export default __webpack_public_path__ + "static/media/noimg_women.177ec39c.jpg";